import {
    DELETION_OF_PHOTOBLOG_COMMENT,
    DELETION_OF_PHOTOBLOG_POST,
} from "@/mk/autogenerated/translation";

import { DeletionTargetType } from "./Deletion.schemas";

export const TITLES = {
    [DeletionTargetType.PhotoblogComment]: DELETION_OF_PHOTOBLOG_COMMENT,
    [DeletionTargetType.PhotoblogPost]: DELETION_OF_PHOTOBLOG_POST,
};
